module.exports = __webpack_public_path__ + "static/img/4.ef3c782.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/4.png
// module id = UvxM
// module chunks = 0